import { IStatsData } from "common/records/Stats";
import { ActionsUnion } from "common/reducers/UtilsTypes";
import { createAction } from "common/reducers/Utils";

export const RECEIVE_STATS = "@stats/RECEIVE_STATS";

export const StatsActions = {
  receiveStats: (orgId: number, stats: Partial<IStatsData>[]) => createAction("@stats/RECEIVE_STATS", { orgId, stats }),
};

export type StatsActions = ActionsUnion<typeof StatsActions>;
